<template>
  <div class="insupai-app">
    <router-view v-if="ifRouterAlive" />
  </div>
</template>

<script>
import {initEffects} from "@/utils/specialEffects.js";
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      ifRouterAlive: true,
    };
  },
  created() {
    initEffects();//初始化特效
    function getTop(e) {
      var offset = e.offsetTop;
      if (e.offsetParent != null) offset += getTop(e.offsetParent);
      return offset;
    }
    function getLeft(e) {
      var offset = e.offsetLeft;
      if (e.offsetParent != null) offset += getLeft(e.offsetParent);
      return offset;
    }
    var hintModal = null;
    let timer = null;
    document.body.addEventListener("mouseover", function (e) {
      if (e.target.getAttribute("data-hornet-hint")) {
        if (timer || hintModal) {
          clearTimeout(timer);
          hintModal && document.body.removeChild(hintModal);
        }
        let hint = e.target.getAttribute("data-hornet-hint");
        let scorllDom = e.target.getAttribute("data-hornet-hint-scroll-id");
        let x = getLeft(e.target);
        let y =
          getTop(e.target) -
          (scorllDom ? document.getElementById(scorllDom).scrollTop : 0);
        hintModal = document.createElement("div");
        hintModal.className = "hint-modal-div";
        hintModal.innerHTML = hint;
        hintModal.style.top = y - 2 + "px";
        hintModal.style.left = x + e.target.offsetWidth / 2 + "px";
        document.body.appendChild(hintModal);
        setTimeout(() => {
          hintModal.className = `${hintModal.className} hint-modal-div-show`;
        }, 20);
      }
    });
    document.body.addEventListener("mouseout", function (e) {
      if (e.target.getAttribute("data-hornet-hint") && hintModal) {
        hintModal.className = `${hintModal.className} hint-modal-div-remove`;
        timer = setTimeout(() => {
          document.body.removeChild(hintModal);
          hintModal = null;
          timer = null;
        }, 200);
      }
    });
  },
  mounted() {
  },
  methods: {
    reload() {
      this.ifRouterAlive = false;
      this.$nextTick(() => {
        this.ifRouterAlive = true;
      });
    }
    
  },
};
</script>

<style lang="scss">
// .el-form--inline .el-form-item {
//     display: inline-block; 

// }
</style>